import type { PaginationProps } from "@/types";

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  const baseBtn =
    "min-w-[40px] h-10 px-3 rounded-md text-sm font-medium flex items-center justify-center transition-colors cursor-pointer";

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap`}
      >
        <i className="ri-arrow-left-s-line mr-1"></i>
        上一页
      </button>

      {pages.map((page, index) =>
        typeof page === "number" ? (
          <button
            key={`page-${page}`}
            type="button"
            onClick={() => onChange(page)}
            className={`${baseBtn} ${
              page === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 text-foreground-700 hover:bg-background-100"
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={`ellipsis-${index}`} className="px-1 text-foreground-400">
            …
          </span>
        )
      )}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap`}
      >
        下一页
        <i className="ri-arrow-right-s-line ml-1"></i>
      </button>
    </nav>
  );
}